import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

// ---------------------- Variables

const enableStore = import.meta.env.VITE_CURRENT_MODE !== "production";

// ---------------------- Interfaces

interface SideMenuState {
  // --------- State

  isOpen: boolean;

  // --------- Actions

  setOpen: () => void;
  setClosed: () => void;
  toggle: () => void;
}

// ---------------------- Store

export const useSideMenuStore = create<SideMenuState>()(
  devtools(
    immer((set) => ({
      // --------- State

      isOpen: false,

      // --------- Actions

      setOpen: () =>
        set(
          (state) => {
            state.isOpen = true;
          },
          false,
          "side-menu/setOpen",
        ),

      setClosed: () =>
        set(
          (state) => {
            state.isOpen = false;
          },
          false,
          "side-menu/setClosed",
        ),

      toggle: () =>
        set(
          (state) => {
            state.isOpen = !state.isOpen;
          },
          false,
          "side-menu/toggle",
        ),
    })),
    {
      name: "SideMenuStore",
      enabled: enableStore,
      store: "SideMenuStore",
    },
  ),
);
